<template>
	<div>
		<div v-if="!showProgress">
			<a-tabs v-model:activeKey="activeKey" class="ftr-1-25" @change="userCoursePackageList">
				<a-tab-pane key="1" :tab="$t('myStudents.onCampusStudents')" >
					<div class="bg-w py-3 px-3 br4 row ftr-1">
						<div class="myStudents-col-14">
							{{$t('myStudents.student')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 所學課程 -->
							{{$t('myStudents.grade')}}
						</div>
						<div class="myStudents-col-14">
							<!-- 所學課程 -->
							{{$t('statusConfirms.coursePackage')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 所學課程 -->
							{{$t('cashDesk.category')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 預付餘額 -->
							{{$t('myStudents.totalHalls')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 剰餘餘額 -->
							{{$t('myStudents.remainingBalance')}}
						</div>
						<div class="myStudents-col-28">
							
						</div>
					</div>
					<div class="bg-w py-3 px-3 br4 row mt-3 ftr-1" style="border-left: 4px solid #52C4C9;"
					v-for="(item,index) in list">
						<div class="myStudents-col-14 flex alcenter" @click="setReport(item)">
							<img :src="item.user_info.avatar" alt="" class="photo-40" />
							<div class="ml10 cl-black">
								{{item.user_info.nickname}}
							</div>
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.grade||$t('common.noContent')}}
						</div>
						<div class="myStudents-col-14 cl-black">
							{{item.course_info.name}}
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.is_experience=='1'?$t('common.experienceClass'): $t('teacherVue.formalClasses')}}
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.quantity}}{{$t('myStudents.classHour')}}
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.residue_quantity}}{{$t('myStudents.classHour')}}
						</div>
						<div class="myStudents-col-28">
							<div class="flex">
								<img src="../../../assets/image/teacher/myStudents1.png" class="myStudents-icon" :title="$t('teacherIndex.textMessage')" alt="" />
								<img src="../../../assets/image/teacher/myStudents2.png" class="myStudents-icon"
								 :title="$t('myStudents.appointmentClass')" alt="" @click="toAppointment(item.id)" />
								<!-- <img src="../../../assets/image/teacher/myStudents3.png" style="width: 35px;height: 35px;"
								class="myStudents-icon" :title="$t('teacherIndex.sellingHall')" alt="" @click="openSend" /> -->
								<img src="../../../assets/image/teacher/myStudents4.png" class="myStudents-icon" @click="toProgress(item)"
								 :title="$t('common.progressReport')" alt="" />
							</div>
						</div>
					</div>
				</a-tab-pane>
				<a-tab-pane key="2" :tab="$t('myStudents.archivedStudents')" >
					<div class="bg-w py-3 px-3 br4 row ftr-1">
						<div class="myStudents-col-14">
							{{$t('myStudents.student')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 所學課程 -->
							{{$t('myStudents.grade')}}
						</div>
						<div class="myStudents-col-14">
							<!-- 所學課程 -->
							{{$t('statusConfirms.coursePackage')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 所學課程 -->
							{{$t('cashDesk.category')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 預付餘額 -->
							{{$t('myStudents.totalHalls')}}
						</div>
						<div class="myStudents-col-10">
							<!-- 剰餘餘額 -->
							{{$t('myStudents.remainingBalance')}}
						</div>
						<div class="myStudents-col-28">
							
						</div>
					</div>
					
					<div class="bg-w py-3 px-3 br4 row mt-3 ftr-1" style="border-left: 4px solid #52C4C9;"
					v-for="(item,index) in list">
						<div class="myStudents-col-14 flex alcenter" @click="setReport(item)">
							<img :src="item.user_info.avatar" alt="" class="photo-40" />
							<div class="ml10 cl-black">
								{{item.user_info.nickname}}
							</div>
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.grade||$t('common.noContent')}}
						</div>
						<div class="myStudents-col-14 cl-black">
							{{item.course_info.name}}
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.is_experience=='1'?$t('common.experienceClass'): $t('teacherVue.formalClasses')}}
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.quantity}}{{$t('myStudents.classHour')}}
						</div>
						<div class="myStudents-col-10 cl-black">
							{{item.residue_quantity}}{{$t('myStudents.classHour')}}
						</div>
						<div class="myStudents-col-28">
							<div class="flex">
								<img src="../../../assets/image/teacher/myStudents1.png" class="myStudents-icon" :title="$t('teacherIndex.textMessage')" alt="" />
								<!-- <img src="../../../assets/image/teacher/myStudents2.png" class="myStudents-icon"
								 :title="$t('myStudents.appointmentClass')" alt="" @click="toAppointment(item.id)" /> -->
								<!-- <img src="../../../assets/image/teacher/myStudents3.png" style="width: 35px;height: 35px;"
								class="myStudents-icon" :title="$t('teacherIndex.sellingHall')" alt="" @click="openSend" /> -->
								<img src="../../../assets/image/teacher/myStudents4.png" class="myStudents-icon" @click="toProgress(item)"
								 :title="$t('common.progressReport')" alt="" />
							</div>
						</div>
					</div>
				</a-tab-pane>
			</a-tabs>
		</div>
		<div class="bg-w p-3" v-else>
			<router-view></router-view>
		</div>
		<div v-if="visible">
			 <a-modal :title="$t('myStudents.studentData')" :width="850" :visible="visible" @cancel="handleCancel()"
			 	:closable="false" :footer="null">
			 	<div class="flex flex-column">
			 		<img :src="selectItem.user_info.avatar" alt="" style="width: 80px;border-radius: 50%;" />
					<div class="cl-info mt-3">
						{{$t('teacherSet.name')}}
					</div>
			 		<div class=" ftr-1-2 ftw600">
			 			{{selectItem.user_info.nickname}}
			 		</div>
					<div class="cl-info mt-3">
						{{$t('userMySetting.gender')}}
					</div>
					<div class="cl-black">
						{{selectItem.user_detail.gender=='1'?$t('userMySetting.male'):$t('userMySetting.female')}}
					</div>
					<div class="flex space mt-3">
						<div style="width: 50%;">
							<div class="cl-info">
								{{$t('myStudents.modal1')}}
							</div>
							<div class="cl-black">
								{{selectItem.user_detail.school_type.name||$t('common.noContent')}}
							</div>
							<div class="cl-info mt-3">
								{{$t('myStudents.modal2')}}
							</div>
							<div class="cl-black">
								{{selectItem.course_info.name}}
							</div>
							<div class="cl-info mt-3">
								{{$t('myStudents.modal3')}}
							</div>
							<div class="cl-black">
								<span class="mr10" v-for="item in selectItem.user_detail.course_names">{{item}}</span>
							</div>
							<div class="cl-info mt-3">
								{{$t('myStudents.modal4')}}
							</div>
							<div class="cl-black">
								{{selectItem.user_detail.learning_objectives}}
							</div>
						</div>
						<div style="width: 50%;">
							<div class="cl-info">
								{{$t('myStudents.modal5')}}
							</div>
							<div class="cl-black">
								{{selectItem.user_detail.school.name||$t('common.noContent')}}
							</div>
							<div class="cl-info mt-3">
								{{$t('myStudents.modal6')}}
							</div>
							<div class="cl-black">
								{{selectItem.user_detail.grade}}
							</div>
							<div class="cl-info mt-3">
								{{$t('myStudents.modal7')}}
							</div>
							<div class="cl-black">
								{{selectItem.user_detail.paper_language}}
							</div>
							<div class="cl-info mt-3">
								{{$t('myStudents.modal8')}}
							</div>
							<div class="cl-black">
								{{selectItem.user_detail.course_language}}
							</div>
						</div>
					</div>
					<div class="flex mt-4">
						<!-- <button type="button" class="btn btn-outline-gray" style="width: 100px;" @click="handleCancel()"> {{$t('common.cancel')}}</button> -->
						<button type="button" class="btn btn-theme ml16" style="width: 100px;" @click="handleCancel">{{$t('introductionTeacher.close')}}</button>
					</div>
			 	</div>
			 	
			 </a-modal>
		</div>
		<a-modal :title="$t('myStudents.sendLesson')" :width="850" :visible="visibleSend" @cancel="visibleSend = false"
		 	:closable="false" :footer="null">
			
			<div class="flex mt-2">
				<div class="py-1 px-3 clickAct" v-for="(item,index) in formTeacherC"
				@click="changeClassType(item) "
				:class="formTeacherTypeId==item.id?'bg-theme border-theme cl-w':'bg-F3F3F3 border-gray'">
					{{item.name}}
				</div>
			</div>
			<div class="flex alcenter">
				<div class="" style="width: 150px;">
				</div>
				<div class="mt-3" style="width: 100px;">
					<!-- 試堂 -->
					{{$t('common.experienceClass')}}
				</div>
				<div class="mt-3">
					<!-- 正式堂 -->
					{{$t('teacherVue.formalClasses')}}
				</div>
			</div>
			<div class="mt-2 row ft14 flex alcenter clickAct" v-for="(it,ind) in formTeacherItem" :key="ind">
				<div class="" style="width: 150px;">
					{{it.name}}
				</div>
				<div class="mt-2 bg-theme cl-w br8 wid-fit px-3 py-1" @click="buyClassTest()" style="height: 62px;">
					<div class="ft16">
						{{getCurrency()}}{{'50'}}
					</div>
					<div class="ft12">
						<!-- 1堂25分鐘課 -->
						{{$t('teacherVue.testClassTime')}}
					</div>
				</div>
				
				<div class="col-md py-2 flex wrap ">
					<div class="border-gray br8 wid-fit p-1 ml5 mt-1" style="width: 100px;"  v-for="itChild in it.teacherCourse"
					@click="buyClass(it.id,it.name,itChild)">
						<div class="ftw600">
							{{getCurrency()}}{{convertCurrency(itChild.once_price)}}
						</div>
						<div class="cl-info ft10">
							<!-- {{itChild.quantity}}堂50分鐘課 -->
							{{$t('teacherVue.formalClassTime',{number:itChild.quantity})}}
						</div>
						<div class="border-theme py-0 px-3 cl-theme ft10 wid-fit">
							{{itChild.discount}}% off
						</div>
					</div>
				</div>
			</div>
			
			<div class="mt-4 flex">
				<span style="width: 70px;" >
					{{$t('cashDesk.subject')}}:
				</span>
				DSE(S.4-6) – 中史
			</div>
			<div class="mt-2 flex">
				<span style="width: 70px;" >
					{{$t('myStudents.coursePackage')}}:
				</span>
				DSE(S.4-6) – 中史
			</div>
			<!-- <div class="mt-2 flex">
				<span style="width: 70px;" >
					{{$t('userCenter.timeLimit')}}:
				</span>
				<a-select style="width: 220px;" size="large" >
					<a-select-option :value="0" >
						{{$t('common.select')}}
					</a-select-option>
					<a-select-option :value="24" >
						24小時
					</a-select-option>
					<a-select-option :value="48" >
						48小時
					</a-select-option>
					<a-select-option :value="72" >
						72小時
					</a-select-option>
				</a-select>
			</div> -->
			<div class="flex center mt-5">
				<div class="btn btn-theme" style="width: 100px;" @click="visibleSend = false">
					{{$t('becomeTeacher.submit')}}
				</div>
			</div>
		</a-modal>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				activeKey: '1',
				list:[],
				visible:false,
				selectItem:{},
				content:'',
				visibleSend:false,
				
				formTeacherC:[],
				formTeacherTypeId:0,
				formTeacherItem:[],
				
				showProgress:false
			}
		},
		created(){
			this.userCoursePackageList()
		},
		 mounted() {
		    // 监听浏览器的返回操作
		    window.onpopstate = (event) => {
		      console.log('浏览器返回按钮被点击');
			  this.showProgress = false
		      // 你可以在这里执行一些操作，比如提示用户是否确认离开
		      // 如：window.confirm("Are you sure you want to leave?");
		    };
		  },
		  beforeDestroy() {
		    // 组件销毁时移除监听
		    window.onpopstate = null;
		  },
		methods:{
			toProgress(item){
				this.showProgress = true
				this.$router.push('/progressReport?item='+JSON.stringify(item))
			},
			// 课程分类
			async openSend(teacherCourse){
				console.log("------teacherInfo",this.teacherInfo);
				await this.$http.api('course/classifyList',{
					teacherCourse:this.teacherInfo.id,
					includeCourse:1,//返回老师课程信息
				}).then(res=>{
					this.formTeacherC=res.list
					this.formTeacherTypeId = res.list[0].id
					// this.formTeacherTypeName =res.list[0].name
					this.formTeacherItem = res.list[0].course
					// this.teacher_course_id = res.list[0].course[0].teacherCourse[0].id
					// this.formTeacherItem.forEach((item,index)=>{
					// 	if(item.teacherCourseDelay.length!=0){
					// 		this.showPrice = true
					// 	}
					// })
					
					this.visibleSend = true
				})
			},
			userCoursePackageList(){
				this.list = []
				this.$http.api('teacher/user/userCoursePackageList',{
					page:1,
					limit:100,
					status:this.activeKey
				}).then(res=>{
					this.list = res.list
				})
			},
			editUserReport(){
				this.$http.api('teacher/user/editUserReport',{
					user_id:this.selectItem.user_id,
					content:this.content
				}).then(res=>{
					this.$message.success(this.$t('myStudents.operationSuccess'),1,()=>{
						this.visible=false
						this.selectItem = {}
						this.content = ''
					})
					
				})
			},
			userReportDetail(){
				this.$http.api('teacher/user/userReportDetail',{
					user_id:this.selectItem.user_id,
				}).then(res=>{
					this.content = res.info.content
					
				})
			},
			toAppointment(id){
				this.$router.push('/teacherAppointment?id='+id)
			},
			handleCancel(){
				this.visible=false
				this.selectItem = {}
			},
			setReport(item){
				this.selectItem = item
				this.userReportDetail()
				this.visible = true
			}
		}
	}
</script>

<style>
	.myStudents-icon{
		width: 30px;
		height: 30px;
		margin: 0 10px;
	}
	.myStudents-col-28{
		display: flex;
		flex: 0 0 auto;
		width: 28%;
		align-items: center;
	}
	.myStudents-col-14{
		display: flex;
		flex: 0 0 auto;
		width: 14%;
		align-items: center;
	}
	.myStudents-col-10{
		display: flex;
		flex: 0 0 auto;
		width: 10%;
		align-items: center;
	}
</style>